import React from 'react';
import { GameOverModal } from './warnings/GameOverModal';
import { BankruptcyWarning } from './warnings/BankruptcyWarning';

interface GameModalsProps {
  showBankruptcyWarning: boolean;
  bankruptcyWarnings: number;
  isGameOver: boolean;
  onCloseBankruptcyWarning: () => void;
  onReturnToMenu: () => void;
}

export function GameModals({
  showBankruptcyWarning,
  bankruptcyWarnings,
  isGameOver,
  onCloseBankruptcyWarning,
  onReturnToMenu
}: GameModalsProps) {
  if (!showBankruptcyWarning && !isGameOver) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-theme-bg-content rounded-lg max-w-md w-full mx-4 overflow-hidden">
        {showBankruptcyWarning && !isGameOver && (
          <BankruptcyWarning
            bankruptcyWarnings={bankruptcyWarnings}
            onClose={onCloseBankruptcyWarning}
          />
        )}
        {isGameOver && (
          <GameOverModal onReturnToMenu={onReturnToMenu} />
        )}
      </div>
    </div>
  );
}